export function registerSiteServiceWorker() {
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => Promise.all(registrations.filter((registration) => new URL(registration.scope).pathname === "/area-paciente").map((registration) => registration.unregister()))).then(() => navigator.serviceWorker.register("/site-sw.js", {
      scope: "/",
      updateViaCache: "none",
    })).then(async (registration) => {
      if (registration.waiting) registration.waiting.postMessage({ type: "SKIP_WAITING" });
      await registration.update();
    }).catch(() => {});
  });
}